import { render, staticRenderFns } from "./generateSpeechSelect.vue?vue&type=template&id=0b0673dc&scoped=true"
import script from "./generateSpeechSelect.vue?vue&type=script&lang=js"
export * from "./generateSpeechSelect.vue?vue&type=script&lang=js"
import style0 from "./generateSpeechSelect.vue?vue&type=style&index=0&id=0b0673dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0673dc",
  null
  
)

export default component.exports